import axios from 'axios'

let isRequestInProgress = false // Флаг для отслеживания выполнения запроса

export default async (props) => {

  if (window.location.host !== 'testing.mts.ru') {
    return
  }

  if (props.user) {
    return
  }

  if (isRequestInProgress) {
    return
  }

  try {
    isRequestInProgress = true // Устанавливаем флаг выполнения запроса

    await axios.get('https://login.mts.ru/amserver/oauth2/sso/validate', {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' }
    })

    window.location.href = '/oauth/redirect?autologin'
  } catch (e) {
    throw new Error(`Ошибка: ${e.response ? e.response.status : e.message}`)
  } finally {
    isRequestInProgress = false // Сбрасываем флаг после завершения запроса
  }
}
